module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28631f46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/changePassword.vue
// module id = 815
// module chunks = 1